var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_6050)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_650_6050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81009 5.33004L6.32693 3.52229C6.52059 2.84562 7.47959 2.84562 7.67326 3.52229L8.18951 5.33004C8.2222 5.44439 8.28348 5.54853 8.36758 5.63263C8.45168 5.71673 8.55582 5.77802 8.67018 5.8107L10.4779 6.32695C11.1546 6.52062 11.1546 7.47962 10.4779 7.67329L8.67018 8.18954C8.55582 8.22222 8.45168 8.28351 8.36758 8.36761C8.28348 8.45171 8.2222 8.55585 8.18951 8.6702L7.67326 10.478C7.47959 11.1546 6.52059 11.1546 6.32693 10.478L5.81068 8.6702C5.77799 8.55585 5.71671 8.45171 5.63261 8.36761C5.54851 8.28351 5.44437 8.22222 5.33001 8.18954L3.52226 7.67329C2.8456 7.47962 2.8456 6.52062 3.52226 6.32695L5.33001 5.8107C5.44437 5.77802 5.54851 5.71673 5.63261 5.63263C5.71671 5.54853 5.77799 5.44439 5.81068 5.33004M10.5608 9.6292C10.7293 9.13745 11.4381 9.13687 11.6061 9.6292L11.6213 9.67995L11.7939 10.373L12.4869 10.5462C13.0469 10.6862 13.0469 11.4807 12.4869 11.6207L11.7939 11.794L11.6213 12.487C11.4813 13.0464 10.6862 13.0464 10.5462 12.487L10.3729 11.794L9.67993 11.6207C9.11993 11.4807 9.11993 10.6856 9.67993 10.5462L10.3729 10.373L10.5462 9.67995L10.5608 9.6292ZM11.0834 10.965C11.0499 11.01 11.01 11.0499 10.965 11.0835C11.01 11.117 11.0499 11.1569 11.0834 11.2019C11.117 11.1569 11.1569 11.117 11.2018 11.0835C11.1568 11.0497 11.117 11.0096 11.0834 10.9645M2.3941 1.46195C2.56793 0.953871 3.31868 0.970787 3.45459 1.5127L3.62726 2.2057L4.32026 2.37895C4.88026 2.51895 4.88026 3.31345 4.32026 3.45345L3.62726 3.6267L3.45459 4.3197C3.31459 4.87912 2.51951 4.87912 2.37951 4.3197L2.20626 3.6267L1.51326 3.45345C0.953262 3.31345 0.953262 2.51837 1.51326 2.37895L2.20626 2.2057L2.37951 1.5127L2.3941 1.46195ZM2.91676 2.79837C2.88315 2.84313 2.84327 2.88281 2.79834 2.9162C2.84335 2.94995 2.88323 2.99004 2.91676 3.0352C2.95029 2.99004 2.99017 2.94995 3.03518 2.9162C2.99022 2.88263 2.95033 2.84333 2.91676 2.79837Z",
    fill: "#573B76"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_650_6050",
    x: -2.90674,
    y: -1.90683,
    width: 19.8135,
    height: 19.8133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_650_6050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_650_6050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_6050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.0886b08ce6b31dccba9d336d43e5e463.svg";
export { ForwardRef as ReactComponent };